import { BaseService } from "@services/BaseService";

class ReportService extends BaseService {
  generateReportDirect(
    projectId: string,
    templateId: number,
    reportName: string,
    payload: any
  ) {
    return this.post(
      `/projects/${projectId}/create_report/?template_id=${templateId}`,
      payload
    );
  }
  exportReport(projectId: string, requestBody: string, reportId: string) {
    return this.post(
      `/projects/${projectId}/export_report/`,
      requestBody,
      {
        headers: { "Content-Type": "text/html" },
        params: { report_id: reportId },
        responseType: "blob",
      },
      undefined, // optional errorText
      true // ✅ fullResponse
    );
  }

  getReportMembers(projectId: string, reportId: string) {
    return this.get(`/projects/${projectId}/reports/${reportId}/get_members`);
  }
  deleteReport(projectId: string, reportId: string) {
    return this.delete(`/projects/${projectId}/reports/${reportId}`);
  }
  getReport(projectId: string, reportId: string, sharedToken?: string) {
    const url = sharedToken
      ? `/projects/p/${sharedToken}/${projectId}/reports/${reportId}`
      : `/projects/${projectId}/reports/${reportId}`;
    return this.get(url);
  }
  getReportsDropdown(projectId: string, sharedToken?: string) {
    const endpoint = sharedToken
      ? `/projects/p/${sharedToken}/${projectId}/reports/dropdown`
      : `/projects/${projectId}/reports/dropdown`;

    return this.get(endpoint);
  }
  getReportById(projectId: string, reportId: number) {
    return this.get(`/projects/${projectId}/reports/${reportId}`);
  }
  updateReport(projectId: string, reportId: string, payload: any) {
    return this.patch(`/projects/${projectId}/reports/${reportId}`, payload);
  }
  getPublicReport(reportId: string) {
    return this.get(`/public/reports/${reportId}`, { withCredentials: true });
  }
  getReports(
    projectId: string,
    params?: { order?: string; offset?: number; limit?: number },
    sharedToken?: string
  ) {
    const endpoint = sharedToken
      ? `/projects/p/${sharedToken}/${projectId}/reports`
      : `/projects/${projectId}/reports`;

    return this.get(endpoint, { params, withCredentials: true });
  }

  grantRole(
    projectId: string,
    reportId: string,
    email: string,
    roleId: number
  ) {
    return this.post(`/projects/${projectId}/reports/${reportId}/grant_role/`, {
      email,
      role_id: roleId,
    });
  }
  revokeRole(projectId: string, reportId: string, memberId: number) {
    return this.post(
      `/projects/${projectId}/reports/${reportId}/revoke_role/`,
      null,
      {
        params: { member_id: memberId },
      }
    );
  }
  toggleReportPublicAccess(
    projectId: string,
    reportId: string,
    isPublic: boolean
  ) {
    return this.post(
      `/projects/${projectId}/reports/${reportId}/public?is_public=${isPublic}`
    );
  }
  publishReport(projectId: string, reportId: string, isPublished: boolean) {
    return this.post(
      `/projects/${projectId}/reports/${reportId}/publish?is_published=${isPublished}`
    );
  }
}

export const reportService = new ReportService();
